import { NgModule } from '@angular/core';
import { HttpService } from './http.service';
import { BaseService } from './base.service';
import { EnvironmentService } from '../environment/environment.service';
import { AuthService } from './auth.service';

@NgModule({
  providers: [
    HttpService,
    BaseService,
    EnvironmentService,
    AuthService,
  ],
})
export class ServicesModule {}
